import { io } from 'socket.io-client';

let socket = null;

function getSocketBaseUrl() {
  if (process.env.REACT_APP_SOCKET_URL) return process.env.REACT_APP_SOCKET_URL;
  // In production, default to same host
  if (process.env.NODE_ENV === 'production') {
    const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
    return `${protocol}://${window.location.host}`;
  }
  // Development default
  return 'http://localhost:5000';
  // return 'https://admin.falppllc.com';
}

export function connect() {
  if (socket && socket.connected) return socket;
  const baseUrl = getSocketBaseUrl();
  socket = io(baseUrl, { transports: ['websocket', 'polling'], withCredentials: true });
  return socket;
}

export function joinSellerRoom(email) {
  if (!email) return;
  connect().emit('join-seller-room', { email });
}

export function joinAccountantRoom(email) {
  if (!email) return;
  connect().emit('join-accountant-room', { email });
}

export function joinAdminRoom() {
  connect().emit('join-admin');
}

export function on(event, handler) {
  connect().on(event, handler);
}

export function off(event, handler) {
  if (!socket) return;
  socket.off(event, handler);
}

export default {
  connect,
  joinSellerRoom,
  joinAccountantRoom,
  joinAdminRoom,
  on,
  off,
};


